import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VUE_DIALOG_CONFIG } from 'vue/utilities/vue-dialog-config';

@Component({
  selector: 'app-all-days',
  standalone: false,
  templateUrl: './all-days.component.html',
  styleUrl: './all-days.component.scss'
})


export class AllDaysComponent implements OnInit {
  datas = [{
    'Date': '1',
    'Gross':'2',
    'Queue':'3',
    'Utilization':'4'
  },{
    'Date': '5',
    'Gross':'6',
    'Queue':'7',
    'Utilization':'8'
  },
  {
    'Date': '9',
    'Gross':'10',
    'Queue':'11',
    'Utilization':'12'
  },
]
constructor(private dialog: MatDialogRef<AllDaysComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,){}

ngOnInit(){

 
}
closed(){
    this.dialog.close();
  }
  
}

export const confirmationalldayModalConfigs = {
  ...VUE_DIALOG_CONFIG,
  width:"600px"
};